import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useOvertime } from "@/contexts/overtime/useOvertime";
import RequestDetail from "@/components/overtime/RequestDetail";
import { Spinner } from "@/components/ui/spinner";
import { useOvertimeSubscription } from "@/hooks/useOvertimeSubscription";
import { useAuth } from "@/contexts/auth";
import { OvertimeRequest } from "@/types";

export function RequestDetails() {
  const { requestId } = useParams<{ requestId: string }>();
  const { getOvertimeRequestById, loading } = useOvertime();
  const [request, setRequest] = useState<OvertimeRequest | null>(null);
  const { user } = useAuth();
  
  // Function to fetch the request details
  const fetchRequestDetails = useCallback(async () => {
    if (requestId) {
      const overtimeRequest = getOvertimeRequestById(requestId);
      setRequest(overtimeRequest);
    }
  }, [requestId, getOvertimeRequestById]);
  
  // Set up real-time subscription
  useOvertimeSubscription({
    user,
    onDataChange: fetchRequestDetails
  });

  useEffect(() => {
    fetchRequestDetails();
  }, [fetchRequestDetails]);

  if (loading) {
    return (
      <div className="flex h-[50vh] items-center justify-center">
        <Spinner className="h-8 w-8" />
      </div>
    );
  }

  if (!request) {
    return (
      <div className="rounded-lg border bg-card p-6 text-center">
        <h2 className="text-lg font-semibold">Request Not Found</h2>
        <p className="text-muted-foreground mt-2">
          The overtime request you're looking for doesn't exist or has been removed.
        </p>
      </div>
    );
  }

  return <RequestDetail request={request} />;
}

export default RequestDetails;
